import { useEffect, useState } from 'react'
import {
  fetchAndActivateRemoteConfig,
  getChatHistoryAsSourceFromRemote,
} from 'configs/firebase'

/**
 * `false` até o fetch; depois reflete `chat_history_as_source` (padrão: false).
 *
 * Fase 3: com ela ligada, o histórico passa a vir do `/history` em vez do
 * `getMessages()` do SDK. Começa desligada de propósito e só deve ser ligada
 * quando o portão da Fase 2 fechar com dado — é o histórico clínico que está
 * em jogo, não uma preferência de UI.
 */
export function useChatHistoryAsSource(): boolean {
  const [enabled, setEnabled] = useState(false)

  useEffect(() => {
    let cancelled = false
    void (async () => {
      await fetchAndActivateRemoteConfig()
      if (cancelled) return
      setEnabled(getChatHistoryAsSourceFromRemote())
    })()
    return () => {
      cancelled = true
    }
  }, [])

  return enabled
}
